import Vue from 'vue'
import createAuth0Client from '@auth0/auth0-spa-js'
import UIUtils from './utils/UIUtils'

let instance

export const getInstance = () => instance

export const useAuth0 = ({ ...pluginOptions }) => {
    if (instance) return instance

    instance = new Vue({
        data() {
            return {
                auth0Client: null,
                isLoading: true,
                isAuthenticated: false,
                user: {},
                error: null
            }
        },

        async created() {
            this.auth0Client = await createAuth0Client(pluginOptions)
            await this.manageAppState()
        },
        methods: {
            async manageAppState() {
                this.isLoading = true
                UIUtils.showLoadingMask()
                try {
                    this.isAuthenticated = await this.auth0Client.isAuthenticated()
                    if (this.isAuthenticated) {
                        this.user = await this.auth0Client.getUser()
                    }
                } catch (e) {
                    this.error = e
                    this.isAuthenticated = false
                } finally {
                    this.isLoading = false
                    UIUtils.hideLoadingMask()
                }
            },
            async login() {
                try {
                    this.isLoading = true
                    this.error = null
                    const res = await this.auth0Client.loginWithPopup(null, {
                        timeoutInSeconds: 60 * 3
                    })
                    await this.manageAppState()
                    return res
                } catch (e) {
                    this.error = e
                    this.isAuthenticated = false
                    if (e.popup) {
                        e.popup.close()
                    }
                }
            },
            logout(options) {
                return this.auth0Client.logout(options)
            },
            async getIdToken() {
                if (this.isAuthenticated) {
                    try {
                        const response = await this.auth0Client.getTokenSilently({
                            detailedResponse: true
                        })
                        return response.id_token
                    } catch (e) {
                        this.isAuthenticated = false
                        this.error = e
                    }
                }
                return null
            }
        }
    })

    return instance
}

/**
 *  Vue.js Plugin Definition
 */

export const Auth0Plugin = {
    install(Vue, options) {
        Vue.prototype.$auth0 = useAuth0(options)
    }
}
